define([
	'../base/PureComponent',
	'./AnalysisWfsData',
	'../utils/GeometryUtil',
	'../g2'
	], function(PureComponent,AnalysisWfsData,GeometryUtil,g2) {
	/**
	 * 构造方法
	 * @constructor
	 * @classdesc 解析文件组件
	 * @augments G.base.PureComponent
	 * @alias G.data.AnalysisFile
	 * @param {Object} options - 必填，构造参数；
	 * @param {G.Map} options.map - 必填，地图对象
	 * @returns {Class} - 实例化的对象
	 */
	var component = PureComponent.extend({
		options: {

		},
		initialize: function(options) {
			PureComponent.prototype.initialize.call(this, options);
		},
		/**
		 * 销毁
		 * @method
		 */
		destroy: function() {
			PureComponent.prototype.destroy.call(this);
		}
	})
	//对外提供的接口
	component.include({
		/**
		 * 解析不同文件类型的接口
		 * @method
		 * @memberOf G.data.AnalysisFile.prototype
		 * @param options {Object} 必填
		 * @param options.fileUrl {String} 必填，文件的路径
		 * @param options.fileType {String} 必填，文件的类型 例：Csv，Shape，Kml，Gml
		 * @param opyions.callback {Function} 必填，解析完文件的回调
		 * @param options.context {context} 必填，上下文
		 * @return geojson {Object} 数据 例：{"type": "FeatureCollection","features": [{"type":"Feature","symbol":{},"properties":{},"geometry":{"type":"MultiPolygon","coordinates":[]}}]}
		 * */
		analysisDifferenceTypeFile: function(options) {
			if(!options.fileUrl || !options.fileType) {
				throw(new Error("参数不完整"));
			}
			var fn = '_analysis' + options.fileType;
			if(typeof this[fn] == 'function') {
				options.layer = layer;
				this[fn](options)
			}
		},
		/**
		 * 解析cvs文件
		 * @method
		 * @param options {Object} 必填
		 * @param options.fileUrl {String} 必填，文件的路径
		 * @param options.fileType {String} 必填，文件的类型 例：Csv，Shape，Kml，Gml
		 * @param opyions.callback {Function} 必填，解析完文件的回调
		 * @param options.context {context} 必填，上下文
		 * */
		_analysisCsv: function(options) {
			window.papaparse.parse(options.fileUrl, {
				download: true,
				complete: function(result) {
					if(result) {
						var data = result.data;
						var indexX, indexY, indexWkt, dataArr = [],
							geojson = {
								"type": "FeatureCollection",
								"features": []
							};
						//匹配搜索各种数据
						for(var i = 0; i < data[0].length; i++) {
							//匹配经度
							if(data[0][i] == 'x' || data[0][i] == 'X' || data[0][i] == 'longitude' || data[0][i] == "LONGITUDE") {
								indexX = i;
							}
							//匹配纬度
							if(data[0][i] == 'y' || data[0][i] == 'Y' || data[0][i] == 'latitude' || data[0][i] == "LATITUDE") {
								indexY = i;
							}
							//匹配wkt线和面的情况
							if(data[0][i] == 'wkt' || data[0][i] == "SDE.ST_ASTEXT(SHAPE)") {
								indexWkt = i;
							}
						}
						for(var key in data) {
							if(key == '0') {
								continue;
							}
							var xyArr = [];
							var feature = {
									"type": "Feature",
									"properties": {},
									"geometry": {},
									"symbol": {}
								},
								symbol = {};
							if(indexX != undefined || indexY != undefined) {
								var geometry = {
									"type": "Point",
									"coordinates": [data[key][indexX], data[key][indexY]]
								}
								symbol.type = "SimpleMarkerSymbol";
								feature.geometry = geometry;
								feature.symbol = symbol;
								geojson.features.push(feature);
							}
							//如果wkt值不为空，解析字符串
							if(indexWkt != undefined) {
								if(!data[key][indexWkt]) {
									break;
								}
								var geometry = GeometryUtil.getGeoJSONWriter().write(GeometryUtil.getWktReader().read(data[key][indexWkt]));
								if(geometry.type == "LineString") {
									symbol.type = "SimpleLineSymbol";
								} else {
									symbol.type = "SimpleFillSymbol";
								}
								feature.geometry = geometry;
								feature.symbol = symbol;
								geojson.features.push(feature);
							}
						}
					}
					if(options.callback && options.context) {
						options.callback.call(options.context, geojson);
					}
				}
			})
		},
		/**
		 * 解析shape文件
		 * @method
		 * @param options {Object} 必填
		 * @param options.fileUrl {String} 必填，文件的路径
		 * @param options.fileType {String} 必填，文件的类型 例：Csv，Shape，Kml，Gml
		 * @param opyions.callback {Function} 必填，解析完文件的回调
		 * @param options.context {context} 必填，上下文
		 * */
		_analysisShape: function(options) {
			window.shp.load(options.fileUrl,
				function(res) {
					var dataArr = [],
						geojson = {
							"type": "FeatureCollection",
							"features": []
						}
					if(res.records.length > 0) {
						dataArr = res.records;
					}
					//不同类型的处理1-点，3-线，5-面
					if(res.shapeType == 1 || res.shapeType == 2) {
						for(var i = 0; i < dataArr.length; i++) {
							var feature = {
									"type": "Feature",
									"properties": {},
									"geometry": {},
									"symbol": {}
								},
								symbol = {},
								geometry = {
									"type": "Point",
									"coordinates": [dataArr[i].shape.content.x, dataArr[i].shape.content.y]
								};
							symbol.type = "SimpleMarkerSymbol";
							feature.geometry = geometry;
							feature.symbol = symbol;
							geojson.features.push(feature);
						}
					} else if(res.shapeType == 3 || res.shapeType == 4) {
						for(var i = 0; i < dataArr.length; i++) {
							var feature = {
									"type": "Feature",
									"properties": {},
									"geometry": {},
									"symbol": {}
								},
								symbol = {},
								points = dataArr[i].shape.content.points;
							var geometry = {
								"type": "LineString",
								"coordinates": []
							}
							if(points.length > 0) {
								for(var j = 0; j < points.length / 2; j++) {
									geometry.coordinates.push([points[2 * j], points[2 * j + 1]]);
								}
							}
							symbol.type = "SimpleLineSymbol";
							feature.geometry = geometry;
							feature.symbol = symbol;
							geojson.features.push(feature);
						}
					} else if(res.shapeType == 5 || res.shapeType == 6) {
						for(var i = 0; i < dataArr.length; i++) {
							var feature = {
									"type": "Feature",
									"properties": {},
									"geometry": {},
									"symbol": {}
								},
								symbol = {};
							var points = dataArr[i].shape.content.points;
							var geometry = {
								"type": "Polygon",
								"coordinates": [
									[]
								]
							}
							if(points.length > 0) {
								for(var j = 0; j < points.length / 2; j++) {
									geometry.coordinates[0].push([points[2 * j], points[2 * j + 1]]);
								}
							}
							symbol.type = "SimpleFillSymbol";
							feature.geometry = geometry;
							feature.symbol = symbol;
							geojson.features.push(feature);
						}
					}
					if(options.callback && options.context) {
						options.callback.call(options.context, geojson);
					}
				},
				function(res) { throw(new Error(res)); }
			);
		},
		/**
		 * 解析Gml文件
		 * @method
		 * @param options {Object} 必填
		 * @param options.fileUrl {String} 必填，文件的路径
		 * @param options.fileType {String} 必填，文件的类型 例：Csv，Shape，Kml，Gml
		 * @param opyions.callback {Function} 必填，解析完文件的回调
		 * @param options.context {context} 必填，上下文
		 * */
		_analysisGml: function(options) {
			$.ajax({
				type: "get",
				url: options.fileUrl,
				dataType: "XML",
				async: true,
				success: function(result) {
					var features = $(result).find('featureMember'),
						geojson = {
							"type": "FeatureCollection",
							"features": []
						}
					features.each(function() {
						var feature = {
							"type": "Feature",
							"properties": {},
							"geometry": {},
							"symbol": {}
						};
						var symbol = {};
						//解析点数据
						if($(this).find('Point').length > 0) {
							var latAndlong = $(this).find('Point').find('pos').text().split(' '); //[y,x]
							var geometry = {
								"type": "Point",
								"coordinates": [latAndlong[1], latAndlong[0]]
							}
							symbol.type = "SimpleMarkerSymbol";
							feature.geometry = geometry;
							feature.symbol = symbol;
							geojson.features.push(feature);
						}
						//解析线数据
						if($(this).find('LineString').length > 0) {
							var lineArr = $(this).find('LineString').find('posList').text().split(' '); //[x,y,x,y]
							var geometry = {
								"type": "LineString",
								"coordinates": []
							}
							for(var j = 0; j < lineArr.length / 2; j++) {
								geometry.coordinates.push([lineArr[2 * j + 1], lineArr[2 * j]])
							}
							symbol.type = "SimpleLineSymbol";
							feature.geometry = geometry;
							feature.symbol = symbol;
							geojson.features.push(feature);
						}
						//to do 解析面数据
						if($(this).find('LinearRing').length > 0) {
							var polygonArr = $(this).find('LinearRing').find('posList').text().split(' '); //[x,y,x,y]
							//多边形
							var geometry = {
								"type": "Polygon",
								"coordinates": [
									[]
								]
							}
							for(var i = 0; i < polygonArr.length / 2; i++) {
								geometry.coordinates[0].push([polygonArr[2 * i + 1], polygonArr[2 * i]]);
							}
							symbol.type = "SimpleFillSymbol";
							feature.geometry = geometry;
							feature.symbol = symbol;
							geojson.features.push(feature);
						}
					})
					if(options.callback && options.context) {
						options.callback.call(options.context, geojson);
					}
				},
				error: function(e) {
					throw(new Error(e.message));
				}
			})
		},
		/**
		 * 解析Kml文件
		 * @method
		 * @param options {Object} 必填
		 * @param options.fileUrl {String} 必填，文件的路径
		 * @param options.fileType {String} 必填，文件的类型 例：Csv，Shape，Kml，Gml
		 * @param opyions.callback {Function} 必填，解析完文件的回调
		 * @param options.context {context} 必填，上下文
		 * */
		_analysisKml: function(options) {
			var self = this;
			$.ajax({
				type: "get",
				url: options.fileUrl,
				dataType: "XML",
				async: true,
				success: function(result) {
					var placemarkData = $(result).find("Placemark");
					var styleArr = $(result).find("Style");
					var features = $(result).find('featureMember'),
						geojson = {
							"type": "FeatureCollection",
							"features": []
						};
					placemarkData.each(function() {
						var feature = {
							"type": "Feature",
							"properties": {},
							"geometry": {},
							"symbol": {}
						}
						var symbol = {};
						//解析点数据
						if($(this).find('Point').length > 0) {
							if($(this).find('styleUrl').length > 0) {
								//获取样式对象
								symbol = self._getSymbolObj(styleArr, $(this).find('styleUrl').text(), "IconStyle");
							}
							var pointArr = $(this).find('Point').find('coordinates').text().split(','); //[x,y,z]
							var geometry = {
								"type": "Point",
								"coordinates": [pointArr[0], pointArr[1]]
							}
							feature.geometry = geometry;
							feature.symbol = symbol;
							geojson.features.push(feature);
						}
						//解析线数据
						if($(this).find('LineString').length > 0) {
							if($(this).find('styleUrl').length > 0) {
								//获取样式对象
								symbol = self._getSymbolObj(styleArr, $(this).find('styleUrl').text(), "LineStyle");
							}
							var lineArr = $(this).find('LineString').find('coordinates').text().split(' '); //[x,y,z]
							var geometry = {
								"type": "LineString",
								"coordinates": []
							}
							for(var i = 0; i < lineArr.length; i++) {
								var pointArr = lineArr[i].split(','); //[x,y,z]
								geometry.coordinates.push([pointArr[0], pointArr[1]])
							}
							feature.geometry = geometry;
							feature.symbol = symbol;
							geojson.features.push(feature);
						}
						//to do 解析面数据
						if($(this).find('LinearRing').length > 0) {
							if($(this).find('styleUrl').length > 0) {
								//获取样式对象
								symbol = self._getSymbolObj(styleArr, $(this).find('styleUrl').text(), "PolyStyle");
							}
							var polygonArr = $(this).find('LinearRing').find('coordinates').text().split(' '); //[x,y,z]
							var geometry = {
								"type": "LineString",
								"coordinates": [
									[]
								]
							}
							//多边形
							for(var i = 0; i < polygonArr.length; i++) {
								var xy = polygonArr[i].split(','); //[x,y,z]
								geometry.coordinates[0].push([xy[0], xy[1]]);
							}
							feature.geometry = geometry;
							feature.symbol = symbol;
							geojson.features.push(feature);
						}
					})
					if(options.callback && options.context) {
						options.callback.call(options.context, geojson);
					}
				},
				error: function(e) {
					throw(new Error(e.message));
				}
			})
		},
		/**
		 * 解析wfs返回数据
		 * @method
		 * @memberOf G.data.AnalysisFile.prototype
		 * @param options {Object} 必填
		 * @param options.wfsData {Array} 必填，wfs请求返回的数据
		 * */
		analysisWfsData: function(options) {
			if(!options.wfsData){
				throw new Error("传入参数错误！");
			}
			var jsonArray = AnalysisWfsData.wfsXmlToJsonDataArray(options.wfsData);
			return jsonArray;
		}
	})
	component.include({
		/**
		 * 生成样式对象
		 * @method
		 * @param styleArr {Array} 文件中的所有样式对象
		 * @param styleId {String} 当前要素所引用的样式id
		 * @param styleType {String} 对应样式的类型 例：LineStyle IconStyle PolyStyle
		 * @return symbol {Object} 符号参数对象
		 * */
		_getSymbolObj: function(styleArr, styleId, styleType) {
			var symbol = {};
			if(styleArr.length > 0) {
				styleArr.each(function() {
					if('#' + $(this)[0].id == styleId) {
						if(styleType == "IconStyle") {
							var scale = $(this).find('scale').text() || 0.2,
								sourceKey = $(this).find('href').text() || undefined,
								rotation = $(this).find('rotation').text() || 0,
								imgWidth = $(this).find('width').text() || undefined,
								imgheight = $(this).find('height').text() || undefined;
							symbol = {
								type: 'PictureMarkerSymbol',
								scale: scale,
								sourceKey: sourceKey, //需要替换成 sourceKey
								width: imgWidth,
								height: imgheight,
								rotation: rotation
							}
						}
						if(styleType == "LineStyle") {
							var style = $(this).find('style').text() || 5,
								width = $(this).find('width').text() || 2,
								color = $(this).find('color').text() || '#ff0000';
							var colorObj = g2.sfs.Color.fromHex(color);
							symbol = {
								type: 'SimpleLineSymbol',
								color: colorObj,
								style: style,
								width: width
							}
						}
						if(styleType == "PolyStyle") {
							var color = $(this).find('color').text() || '#ff0000',
								borderThickness = $(this).find('borderThickness').text() || 0,
								opacity = $(this).find('opacity').text() || 1;
							var colorObj = g2.sfs.Color.fromHex(color);
							symbol = {
								type: 'SimpleFillSymbol',
								borderColor: colorObj,
								fillColor: colorObj,
								borderThickness: borderThickness,
								opacity: opacity
							}
						}
					}
				})
			}
			return symbol;
		}
	})
	return component;
})
